module.exports = __webpack_public_path__ + "static/media/chatbot.c41bd053.svg";